type PricingProfileResponse = {
  id: number;
  productId: string;
  description: string;
  numberPolicyMatriz: string;
  type: string;
  typeOfMoney: string;
  typeOfCoverage: string;
};

export function MakeEmpty(): PricingProfileResponse {
  return {
    id: 0,
    productId: '',
    description: '',
    numberPolicyMatriz: '',
    type: '',
    typeOfMoney: '',
    typeOfCoverage: '',
  };
}

export default PricingProfileResponse;
